import url from 'url'
import install from './install'
import { appendQuery } from '@/utils'
import { getSignature, rjhyUserLogin, getUserByToken } from '@/api'
import { setStorage, getStorage } from '@/utils/storage.js'
// 微信API列表
const methods = [
  'checkJsApi',
  'onMenuShareTimeline',
  'onMenuShareAppMessage',
  'onMenuShareQQ',
  'onMenuShareWeibo',
  'onMenuShareQZone',
  'chooseImage',
  'previewImage',
  'uploadImage',
  'startRecord',
  'stopRecord',
  'onVoiceRecordEnd',
  'playVoice',
  'pauseVoice',
  'stopVoice',
  'onVoicePlayEnd',
  'uploadVoice',
  'downloadVoice',
  'translateVoice',
  'getNetworkType',
  'openLocation',
  'getLocation',
  'startSearchBeacons',
  'stopSearchBeacons',
  'onSearchBeacons',
  'closeWindow',
  'hideMenuItems',
  'showMenuItems',
  'hideAllNonBaseMenuItem',
  'showAllNonBaseMenuItem',
  'scanQRCode',
  'openProductSpecificView',
  'chooseCard',
  'addCard',
  'openCard',
  'chooseWXPay'
]

const deferred = {}
deferred.promise = new Promise((resolve, reject) => {
  deferred.resolve = resolve
  deferred.reject = reject
})


export default class Wechat {
  /**
   * options
   *   debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
   *   appId: '', // 必填，公众号的唯一标识
   *   timestamp: , // 必填，生成签名的时间戳
   *   nonceStr: '', // 必填，生成签名的随机串
   *   signature: '',// 必填，签名，见附录1
   *   jsApiList: [] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
   */
  constructor(options) {
    this.options = options
    this.install = install
  }

  _resolve() {
    deferred.resolve()
  }

  static _reject() {
    deferred.reject()
  }

  init(config) {
    this.options = Object.assign({}, this.options, config)
  }

  ready() {
    return deferred.promise
  }

  async config(ready, error) {
    const signature = await this.getSignature()

    const options = {
      // debug: env === ('integration' || 'local'),
      appId: this.options.appId,
      timestamp: signature.timestamp,
      nonceStr: signature.nonceStr,
      signature: signature.signature,
      jsApiList: signature.jsApiList,
      openTagList: ['wx-open-subscribe']
    }
    window.wx.config(options)
    return new Promise((resolve, reject) => {
      const timeout = 5000
      setTimeout(() => {
        resolve()
      }, timeout)
      window.wx.ready(function () {
        if (typeof ready === 'function') ready('ok')
        resolve('ok')
      })
      window.wx.error((res) => {
        if (typeof error === 'function') error(res)
        reject(res)
      })

    })
  }

  async getUserInfoByToken(token) {
    // 通过token获取info
    const userData = await getUserByToken({
      token,
      serverId: this.options.serverId || 200,
    })
    if (userData.code !== 1) {
      return false
    } else {
      let obj = {
        country: userData.country,
        openid: userData.openId,
        jfNumber: userData.jfNumber,
        md5Phone:  userData.md5Phone,
        unionid: userData.unionid,
        originid: this.options.originId,
        hasBind: userData.phone,
        isConsultant: userData.isConsultant,
        username: userData.username,
        uid: userData.username,
        userId: userData.username,
        roomToken: userData.roomToken,
        gender: userData.gender,
        token
      }
      setStorage('userInfo', obj)
      return obj
    }

  }

  /**
   * 获取用户基本信息
   *
   *
   * @memberOf Wechat
   */
  async getUserInfo(config) {
    let query = url.parse(window.location.toString(), true).query
    const localCode = getStorage('queryCode')
    let wechatUserLocal = null
    if (window.sessionStorage) {
      try {
        let userStr = sessionStorage.getItem('userInfo')
        wechatUserLocal = JSON.parse(userStr)
      } catch (err) {
        console.log('parse wechatUserLocal err')
        console.log(err)
      }
    }

    if (query.token) {
      const getUserInfoByTokenRes = await this.getUserInfoByToken(query.token)
      if (getUserInfoByTokenRes !== false) return getUserInfoByTokenRes
    }

    if (!wechatUserLocal && (!query.code || query.code === localCode)) {
      this.redirect(appendQuery(window.location.href, { state: null, code: null }, { removeNull: true }))
      return false
    }

    let rjhyUserData = await rjhyUserLogin(Object.assign({
      code: query.code
    }, config))


    if (rjhyUserData.data.code !== 1) {
      if (rjhyUserData.data.code === -6308) { // 快照用户
        return {
          isSnapshotUser: 1
        }
      } else {
        this.redirect(appendQuery(window.location.href, { state: null, code: null }, { removeNull: true }))
        return false
      }

    }

    const {
      attachment,
      roomToken,
      username,
      gender,
      phone,
      token,
      jfNumber,
      md5Phone,
      country,
      openid,
      unionid
    } = rjhyUserData.data.data

    let obj = {
      country,
      openid,
      jfNumber,
      md5Phone,
      unionid,
      originid: config.originId,
      hasBind: phone,
      isConsultant: attachment && attachment.isConsultant,
      username,
      uid: username,
      userId: username,
      roomToken,
      gender,
      token
    }
    setStorage('queryCode', query.code)
    setStorage('userInfo', obj)
    return obj
  }

  getQuery() {
    const query = url.parse(window.location.toString(), true).query
    if (query && query.token) return query
    let cacheToken = localStorage.getItem('token')
    let serverId = localStorage.getItem('serverId')
    if (cacheToken) return { token: cacheToken, serverId }
    return {}
  }

  /**
   * JS SDK 签名
   *
   *
   * @memberOf Wechat
   */
  async getSignature() {
    const signatureData = await getSignature({
      url: window.location.href.replace(`${window.location.hash}`, ''),
      originId: this.options.originId
    })
    return signatureData
  }

  /**
   * 生成重定向链接
   */
  generateRedirectUri(uri) {
    const options = this.options
    return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${options.appId}&redirect_uri=${encodeURIComponent(uri)}&response_type=code&scope=${options.scope}&state=${options.state}#wechat_redirect`
  }

  /**
   * 重定向获取code
   */
  redirect(uri) {
    window.location.href = this.generateRedirectUri(uri)
  }

  onMenuShare(options) {
    const shareMethods = [
      'onMenuShareTimeline',
      'onMenuShareAppMessage',
      'onMenuShareQQ',
      'onMenuShareWeibo',
      'onMenuShareQZone'
    ]

    shareMethods.forEach(method => {
      this[method](options)
    })
  }
}

/**
 * 封装微信API,返回Promise
 */
methods.forEach((method) => {
  Wechat.prototype[method] = function (options = {}) {
    if (!window.wx) return

    let { success, fail, cancel } = options

    // if (!options.success && !options.fail) {
    let promise = new Promise((resolve, reject) => {
      // let success = null
      options.success = (...args) => {
        if (typeof success === 'function') {
          success()
        }
        resolve(...args)
      }
      options.fail = (...args) => {
        if (typeof fail === 'function') {
          fail()
        }
        reject(...args)
      }
      options.cancel = (...args) => {
        if (typeof cancel === 'function') {
          cancel()
        }
        reject(...args)
      }
    })

    window.wx[method](options)
    return promise
  }
})

